const login = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/login`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const register = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/register`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const verify = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/verification`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const resendOtp = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/resend-otp`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const forgotPassword = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/forgot-password`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const resetPassword = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/reset-password`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const activate = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/re-activate`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const loginWithStarfish = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/login-with-starfish`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

const loginWithGoogle = async (formData) => {
    const response = await axios
        .post(`${process.env.MIX_APP_URL}/login-with-google`, formData)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return err.response;
        });

    return response;
};

export {
    login,
    register,
    verify,
    resendOtp,
    forgotPassword,
    resetPassword,
    activate,
    loginWithStarfish,
    loginWithGoogle
};
